// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"59eb4b90","237":"2e0a2a9f","422":"940c35db","480":"678d1820","744":"ae3189fe","801":"164f5eeb","866":"0f74cb18","895":"1946ccf8"}[chunkId] + ".chunk.js";
};